<template>
    <div>

        <v-card>
    <v-card-title>
      <h2>Products Inventory</h2>
      <v-spacer></v-spacer><v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    
        <v-data-table
            :headers="headers"
            :items="products"
            :items-per-page="15"
            :search="search"
            class="elevation-1"
        >
        <template #item.inventory.quantity_received="{ item }">
      <v-chip
        color="black"
        dark
      >
        {{ item.inventory.quantity_received }}
      </v-chip>
    </template>
    <template #item.inventory.quantity_sold="{ item }">
      <v-chip
        color="purple"
        dark
      >
        {{ item.inventory.quantity_sold}}
      </v-chip>
    </template>
    <template #item.inventory.quantity_in_stock="{ item }">
      <v-chip
        :color="item.inventory.quantity_in_stock < 5 ? 'red' : item.inventory.quantity_in_stock >= 5 && item.inventory.quantity_in_stock < 10 ? 'warning' : 'green'"
        dark
      >
        {{ item.inventory.quantity_in_stock }}
      </v-chip>
    </template>

        <template #item.inventory.amount_received="{ item }">
      <v-chip
        color="blue"
        dark
      >
        {{ getCurrency +' '+ formatMoney(item.inventory.amount_received) }}
      </v-chip>
    </template>

    <template #item.inventory.amount_sold="{ item }">
      <v-chip
        color="purple"
        dark
      >
        {{ getCurrency +' '+ formatMoney(item.inventory.amount_sold) }}
      </v-chip>
    </template>

    <template #item.inventory.amount_in_stock="{ item }">
      <v-chip
        color="teal"
        dark
      >
        {{ getCurrency +' '+ formatMoney(item.inventory.amount_in_stock) }}
      </v-chip>
    </template>


</v-data-table>
</v-card>
    </div>
</template>

<script>
import helpersJs from "@/plugins/helpers"
import productsAndServicesJs from "@/plugins/productsAndServices"

    export default {
        mounted(){
            this.getAllProducts()
        },
        computed:{
            getCurrency(){
                return this.$store.getters.getCurrency
            }
        },
        data: () => ({
            search:'',
            products:[],
            headers: [
            {
            text: 'Product Name',
            align: 'start',
            sortable: true,
            value: 'name',
          },
          {
            text: 'Quantity Received',
            value: 'inventory.quantity_received',
          },
          { text: 'Quantity Sold', value: 'inventory.quantity_sold' },
          { text: 'Quantity In Stock', value: 'inventory.quantity_in_stock' },
          { text: 'Amount Received', value: 'inventory.amount_received' },
          { text: 'Amount Sold', value: 'inventory.amount_sold' },
          { text: 'Amount In Stock', value: 'inventory.amount_in_stock' },
        ],
        }),
        methods:{
            async getAllProducts(){
                this.products = await productsAndServicesJs.getAllProducts()
            },
            formatMoney(amount){
                return helpersJs.formatMoney(amount)
            },
        }
    }
</script>